import RichTextComponent from '@components/rich-text/rich-text.view';

export default RichTextComponent;
